import { debounce } from '@theme/utilities';

const OFFSET_BOTTOM = 40;

class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    const header = document.querySelector('header-component');

    if (!(header instanceof HTMLElement)) {
      this.initObserver();
      return;
    }

    const update = debounce(() => {
      this.headerHeight = header.offsetHeight;
      this.initObserver();
    }, 300).bind(this);

    this.headerRO = new ResizeObserver(update);
    this.headerRO.observe(header);
    update();
  }

  initObserver() {
    this.targetEl = document.querySelector('.shopify-product-form');
    if (!this.targetEl) return;

    this.observer?.disconnect();

    const headerHeight = typeof this.headerHeight === 'number' ? this.headerHeight : 0;
    const margin = `${-headerHeight}px 0px -${OFFSET_BOTTOM}px 0px`;
    this.observer = new IntersectionObserver(([entry]) => (entry && entry.isIntersecting ? this.hide() : this.show()), {
      root: null,
      threshold: 0,
      rootMargin: margin,
    });

    this.observer.observe(this.targetEl);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.headerRO?.disconnect();
  }

  show() {
    this.classList.add('show');
  }

  hide() {
    this.classList.remove('show');
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
